module.exports = __webpack_public_path__ + "static/media/twitter-darkmode.a48f85c8.svg";